<script lang="ts">
  import { theme } from "./store";
  import { Modals, closeModal } from "svelte-modals";

  import { NotificationDisplay, notifier } from "@beyonk/svelte-notifications";

  export let name: string;

  import { openModal } from "svelte-modals";
  import Modal from "./Modal.svelte";

  function handleClickOpenModal() {
    openModal(Modal, { title: "Alert", message: "This is an alert" });
  }

  function someFunction() {
    notifier.success("Notifications work!");
  }


</script>

<NotificationDisplay />

<Modals>
  <div slot="backdrop" class="backdrop" on:click={closeModal} />
</Modals>

<main>
  <h1>Hello {name}! {$theme}</h1>
  <p>Visit the <a href="https://svelte.dev/tutorial">Svelte tutorial</a> to learn how to build Svelte apps.</p>

  <button on:click={() => theme.set("light")}> light </button>
  <button on:click={() => theme.set("dark")}> dark </button>

  <br />
  <button on:click={handleClickOpenModal}>Open Modal</button>
  <br />
	<button on:click={someFunction}>Show message</button>

</main>

<style>
  main {
    text-align: center;
    padding: 1em;
    max-width: 240px;
    margin: 0 auto;
  }

  h1 {
    color: #ff3e00;
    text-transform: uppercase;
    font-size: 4em;
    font-weight: 100;
  }

  @media (min-width: 640px) {
    main {
      max-width: none;
    }
  }

  .backdrop {
    position: fixed;
    top: 0;
    bottom: 0;
    right: 0;
    left: 0;
    background: rgba(0, 0, 0, 0.5);
  }
</style>
